<div class="main-container">
    <div class="route">
        <router-outlet appUnloadBrowserNotification></router-outlet>
        <div id="twilio-webchat-widget-root"></div>
    </div>
    <app-footer></app-footer>
</div>